import { useState } from 'react';
import { Loader2, MailCheck } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { AuthShell, authInputClass, authButtonClass } from '../../components/auth/AuthShell';
import { postJson } from '../../lib/authFlows';

export default function ForgotPasswordPage({ apiBase, loginPath, variant }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const d = await postJson(`${apiBase}/forgot-password`, { email });
      setSent(d.message);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell variant={variant} loginPath={loginPath} testId="forgot-password-page"
      title="Şifremi unuttum" subtitle="E-posta adresinizi yazın, size şifre sıfırlama linki gönderelim.">
      {sent ? (
        <div className="flex items-start gap-3 rounded-xl p-4 bg-emerald-500/10 border border-emerald-500/30" data-testid="forgot-password-sent">
          <MailCheck className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-0.5" />
          <p className={`text-sm ${variant === 'hesap' ? 'text-slate-200' : ''}`}>{sent} Gelen kutunuzu ve spam klasörünü kontrol edin. Link 1 saat geçerlidir.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="ornek@gmail.com"
            className={authInputClass(variant)} data-testid="forgot-password-email-input" />
          {error && <p className="text-sm text-red-500" data-testid="forgot-password-error">{error}</p>}
          <Button type="submit" disabled={loading} className={authButtonClass(variant)} data-testid="forgot-password-submit-btn">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Sıfırlama Linki Gönder'}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
